import React, { Component } from "react";
import {Modal, Button, FormGroup, FormControl, ControlLabel, Grid, Row, Col, Image, Checkbox } from "react-bootstrap";
import ReactLoading from 'react-loading';

import './style.css';


//Props:
//message - "Loading. . ." by default
//isShowing - duh

class AlertModal extends Component {

    constructor(props, context) {
        super(props, context);

        this.handleExitButton = this.handleExitButton.bind(this);
        this.handleContinue = this.handleContinue.bind(this);

        this.state = {
            message: this.props.message,
        };
    }

    handleExitButton(){
        this.props.cancelButton();
    }

    handleContinue(){
        this.props.continueButton();
    }

    render () {
        return (
            <Modal style={{marginTop: "10%"}}show={this.props.isShowing} onHide={()=>{}}>
                <Modal.Body className="warning-body">
                    <h1 className="warning-header">Warning!</h1>
                    <h3 className="warning-message">{this.props.message}</h3>
                    <h2 className="warning-action">Which action do you prefer?</h2>
                    <div className="modal-buttons">
                        <Button className="red-btn" onClick={this.handleExitButton}>Exit & Discard</Button>
                        <Button className="green-btn" onClick={this.handleContinue}>Continue Editing</Button>
                    </div>
                </Modal.Body>
             </Modal>
        );
    }
}

export default AlertModal;
